import { ENDPOINT } from '~/constants';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  TopAccountingReferencesBreakdownQueryParams,
  TopAccountingReferencesBreakdownResponse,
} from './types';
import {
  zodTopAccountingReferencesBreakdownEndpointSchema,
  zodTopAccountingReferencesBreakdownQueryParamsSchema,
  zodTopAccountingReferencesBreakdownResponseSchema,
} from './validations';

/**
 * Fetches the top accounting references breakdown data from the API with the given query parameters.
 *
 * @param queryParams - The query parameters for fetching the top accounting references breakdown.
 * @param options - Additional options for the request (e.g., abort signal).
 * @returns The top accounting references breakdown data.
 * @throws Error if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Accounting-Reference/operation/get_top_accounting_references_breakdown_accounting_reference_statistics_top_accounting_references_post
 */
export const fetchTopAccountingReferencesBreakdown = async (
  queryParams: TopAccountingReferencesBreakdownQueryParams,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .post(ENDPOINT.ANALYTICS.GET_TOP_ACCOUNTING_REFERENCES_BREAKDOWN(), {
      json: queryParams,
      validate: {
        body: zodTopAccountingReferencesBreakdownQueryParamsSchema,
        pathSegments: zodTopAccountingReferencesBreakdownEndpointSchema,
      },
      ...options,
    })
    .json<TopAccountingReferencesBreakdownResponse>();

  // Validate the response
  const validatedResponse =
    zodTopAccountingReferencesBreakdownResponseSchema.parse(response);

  return validatedResponse;
};
